import styled from 'styled-components'
import { rem } from 'polished'
import Image from 'components/Common/Image'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TextLink from 'LuxKit/TextLink'
import Label from 'LuxKit/Label'
import Group from 'components/utils/Group'

const Container = styled.div`
  display: grid;
  grid-template-columns: ${rem(100)} ${rem(247)};
  gap: ${rem(20)};
  max-height: ${rem(120)};
  min-width: ${rem(367)};
  max-width: ${rem(367)};
`

const Tag = styled(Label)`
  width: fit-content;
`

export function ContentfulImageTextTile(props: App.ComponentImageTextTile) {
  return (
    <Container>
      <Image image={props.image} width={100} height={120} fit="center" />
      <Group direction="vertical" verticalAlign="space-between">
        <Group direction="vertical" gap={4}>
          {!!props.tag && <Tag children={props.tag} variant="highlight" kind="primary" />}
          <BodyTextBlock variant="medium" weight="bold">{props.title}</BodyTextBlock>
          {!!props.subtitle && <BodyTextBlock variant="medium" weight="normal" colour="light-foreground-alt">{props.subtitle}</BodyTextBlock>}
        </Group>
        {props.linkTo ?
            <TextLink weight="bold" size="medium" underline href={props.linkTo}>{props.linkText}</TextLink> : <TextLink weight="bold" size="medium" underline>{props.linkText}</TextLink>}
      </Group>
    </Container>
  )
}
